import React from 'react';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { AppState } from '../../../store';
import { IProduct, IProductPrice } from '../../../types';
import Price from './Price';
import { IProductsState, IState } from '../../../types/store/reducer';
import { datacatalog } from 'googleapis/build/src/apis/datacatalog';


type IContentWithPriceProps = {
  id: string;
  contentWrapper: string;
  Tag: any;
  isDiscount? : boolean;
  isDiscountItem? : boolean;
};

const ContentWithPrice = ({
  contentWrapper,
  Tag,
  isDiscount,
  isDiscountItem
}: IContentWithPriceProps) => {
  let products : IProductsState = useSelector(( state  : IState) => state.products);

  return (
    <Tag>
      {products.data.length !== 0 ? (
        <Price
          price={(isDiscountItem) ? products.data[0].promoPrice :  products.data[0].regularPrice}
          localeId={products.localeId}
          currency={products.currency}
          content={contentWrapper}
          isDiscount = {isDiscount}
          isDiscountItem = {isDiscountItem}
        />
      ) : (
        '...'
      )}
    </Tag>
  );
};

export default ContentWithPrice;
